// extracted by mini-css-extract-plugin
export default {"tabsContainer":"theme_tabsContainer__OBJR0","tab":"theme_tab__V0WW7","selected":"theme_selected__2JTlY","disabled":"theme_disabled__mcOZF"};